module.exports = __webpack_public_path__ + "img/instruction0.20ac94fd.png";